module.exports = __webpack_public_path__ + "img/transfer_va.545c1082.png";